module.exports = __webpack_public_path__ + "img/2.9e66886c.jpg";